export default "__VITE_ASSET__CsXK6lPq__"